<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="450">
    <v-card class="mx-auto" flat>
      <v-card class="mx-auto" height="300" max-width="450">
        <v-img
          class="white--text"
          height="300"
          :src="impactTypeItem.src"
          gradient="to top right, rgba(30, 30, 30, 0.58), rgba(30, 30, 30, 0.58)"
        >
          <v-card-title
            >{{ $t(impactTypeItem.dialogTitle) }}
            <v-spacer />
            <v-btn icon color="white" @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-subtitle v-html="$t(impactTypeItem.dialogSubtitle)"> </v-card-subtitle>
        </v-img>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import { IThgImpact } from "@/views/thg/interface/ThgImpact.interface";

@Component
export default class BadConscienceDialog extends Vue {
  @Prop()
  impactTypeItem!: IThgImpact;

  dialog = false;

  openDialog() {
    this.dialog = true;
  }

  closeDialog() {
    this.dialog = false;
  }
}
</script>

<style>
.form {
  margin-top: 20px;
}
</style>
